var ctLoginComponent;
(function ($) {
	$.fn.capitechLogin = function () {
		var $capitechLoginElm = $(this);
		var options = {};
		plugin = this;


		// functions
		/*////////////////////////////////////////////////////////////*/
		function init() {
			loaderIndicator(true);
			initKnockoutObject();
			getApplicationSettings();
		}

		function initKnockoutObject() {
			options = {
				extend: {
					"{root}": function (root) {
						root.clientId = ko.observable();
						root.rememberLogin = ko.observable(false);
						root.signInUrl = ko.observable("");
						root.simployerAuthority = ko.observable("");
						root.externalAuthUrlWithClientId = ko.observable("");
						root.bUseAzureLogin = ko.observable(false);
						root.bUseSimployerSaamLogin = ko.observable(false);
						root.bClientSelectionAfterLogin = ko.observable(false);
						root.bUseInternalAuth = ko.observable(false);
						root.bCanChangePassword = ko.observable(false);
						root.bCanDisplayForgotPassword = ko.observable(false);
						root.bIsShowingForgotPassword = ko.observable(false);
						root.simployerGlobalMenuCssUrl = ko.observable("");
						root.simployerGlobalMenuJsUrl = ko.observable("");
						root.theme = ko.observable("capitech");
						root.email = ko.observable("");
						root.loginType = ko.observable("");
						root.bMultiLogin = ko.computed(function() {
							return root.bUseInternalAuth() && root.bUseAzureLogin();
						}, root);
						root.loginFormChanged = function (obj, event) {
							setCookie(CLIENTID_COOKIE_NAME, obj.clientId(), 365);
							setCookie(REMEMBERME_COOKIE_NAME, obj.rememberLogin(), 365);
							// Generate login URL
							var loginUrl = obj.signInUrl();

							if (loginUrl && obj.bUseAzureLogin()) {
								loginUrl =  updateURLParameter(loginUrl, "capitechClientId", obj.clientId());
								loginUrl =  updateURLParameter(loginUrl, "rememberLogin", obj.rememberLogin());
								loginUrl =  updateURLParameter(loginUrl, "returnUrl", encodeURIComponent(window.location.href));
								obj.externalAuthUrlWithClientId(loginUrl);
							}
						},
						root.toggleShowForgotPassword = function (obj, event) {
							obj.bIsShowingForgotPassword(!obj.bIsShowingForgotPassword());
						},
						root.submitRequestNewPasswordForUser = function(obj, event) {
							var isEmailValid = validateEmailAddress(obj.email());
							var isCliendIdValid = obj.clientId() && obj.clientId() > 0;

							if (!isEmailValid || !isCliendIdValid) {
								sweetAlert(getResource("app.validationErrorTitle"), getResource("app.validationErrorForgotPasswordText"), "error");
							} else {
								loaderIndicator(true);
								_api.forgotPassword_POST(
									function (data, textStatus, jqXHR) {
										loaderIndicator(false);
										if (data.success === true) {
											sweetAlert(getResource("app.informationTitle"), getResource("app.forgotPasswordRequestedText"), "info");
										} else {
											sweetAlert("Error", handleServerErrorMessage(data.displayErrorMessage), "warning");
										}
									},
									function (jqXHR, textStatus, errorThrown) {
										loaderIndicator(false);
										displayAjaxErrorAlert(jqXHR, true);
									},
									obj.clientId(),
									obj.email(),
									_appSettingsObj.languageShort
								);	
							}
						}
					},
					"{root}.clients[i]": function(client) {
						// Automatically generated by JSON returned from API
					}
				}
			}
			var initDummyData = {
				clients: []
			};
			ctLoginComponent = ko.viewmodel.fromModel(initDummyData, options);
			ko.applyBindings(ctLoginComponent, $capitechLoginElm[0]);
		}

		function getApplicationSettings() {
			var displayMessage = getURLVariable("message");
			if (!!displayMessage) {
				sweetAlert("Information", decodeURIComponent(displayMessage), "info");
			}
			
			_api.getSettings_GET(
				function (data, textStatus, jqXHR) {
					loaderIndicator(false);
					if (data.success === true && data.content.length > 0) {
						var settings = data.content[0];
						var simployerGlobalMenuJsUrl = settings.simployerGlobalMenuJsUrl;
						var signOutUrl = "";
						if (settings.signOutUrl) {
							signOutUrl = updateURLParameter(settings.signOutUrl, "sid", encodeURIComponent(getCookie(SIMPLOYER_SID_COOKIE_NAME)));
							simployerGlobalMenuJsUrl = updateURLParameter(simployerGlobalMenuJsUrl, "logoutUrl", encodeURIComponent(signOutUrl));
						}
						ctLoginComponent.signInUrl(settings.signInUrl);
						ctLoginComponent.simployerAuthority(settings.simployerAuthority);
						ctLoginComponent.bUseAzureLogin(settings.loginAzure);
						ctLoginComponent.bUseSimployerSaamLogin(settings.loginSimployerSaam);
						ctLoginComponent.bClientSelectionAfterLogin(settings.clientSelectionAftherLogin);
						ctLoginComponent.bUseInternalAuth(settings.loginUserNameAndPassword);
						ctLoginComponent.bCanDisplayForgotPassword(settings.showForgotPassword);
						ctLoginComponent.bCanChangePassword(settings.showChangePassword);
						ctLoginComponent.simployerGlobalMenuCssUrl(settings.simployerGlobalMenuCssUrl);
						ctLoginComponent.simployerGlobalMenuJsUrl(simployerGlobalMenuJsUrl);
						ctLoginComponent.theme(settings.theme);
						setLocalStorage("simployerGlobalMenuJsUrl", ctLoginComponent.simployerGlobalMenuJsUrl());
						setLocalStorage("simployerGlobalMenuCssUrl", ctLoginComponent.simployerGlobalMenuCssUrl());
						setLocalStorage("myCapitechTheme", ctLoginComponent.theme());
						setLocalStorage("clientSelectionAfterLogin", ctLoginComponent.bClientSelectionAfterLogin());
						setLocalStorage("showChangePassword", ctLoginComponent.bCanChangePassword());
						setLocalStorage("showForgotPassword", ctLoginComponent.bCanDisplayForgotPassword());
						setLocalStorage("signOutUrl", signOutUrl);
						loadTheme();
						tryLoginWithToken();
					} else {
						displayAjaxErrorAlert(jqXHR, false);
					}
				},
				function (jqXHR, textStatus, errorThrown) {
					loaderIndicator(false);
					displayAjaxErrorAlert(jqXHR, true);
				}
			);
		}

		function getFlowClients() {
			_api.getAvaliableCapitechClients_POST(
				function (data, textStatus, jqXHR) {
					loaderIndicator(false);
					if (data.success === true && data.content.length > 0) {
						var clients = data.content;
						for (var client = 0; client < clients.length; client++) {
							ctLoginComponent.clients.push(clients[client]);
						}
						ctLoginComponent.clientId(getCookie(CLIENTID_COOKIE_NAME));
						ctLoginComponent.rememberLogin(getCookie(REMEMBERME_COOKIE_NAME) ? getCookie(REMEMBERME_COOKIE_NAME) : false);
						ctLoginComponent.loginFormChanged(ctLoginComponent);
						showLoginForm();
					} else {
						sweetAlert("No clients", "Can't recieve clients.", "error");
					}
				},
				function (jqXHR, textStatus, errorThrown) {
					loaderIndicator(false);
					displayAjaxErrorAlert(jqXHR, true);
				}
			);
		}

		function tryLoginWithToken() {
			var clientId = getCookie(CLIENTID_COOKIE_NAME);
			var refreshToken = getCookie(REFRESHTOKEN_COOKIE_NAME);
			var rememberMe = getCookie(REMEMBERME_COOKIE_NAME);

			if ((clientId && refreshToken && ((rememberMe && rememberMe === true)) || getURLVariable("isAuthenticated") === "true")) {
				// Check URL variables (Used for Azure and Simployer)
				var urlClientId = getURLVariable("my-capitech-clientid");
				var urlRefreshToken = getURLVariable("my-capitech-refresh-token");
				if (urlClientId !== undefined && urlClientId !== null && urlClientId.length > 0) {
					setCookie(CLIENTID_COOKIE_NAME, urlClientId);
					clientId = urlClientId;
				}
				if (urlRefreshToken !== undefined && urlRefreshToken !== null && urlRefreshToken.length > 0) {
					setCookie(REFRESHTOKEN_COOKIE_NAME, urlRefreshToken);
					refreshToken = urlRefreshToken;
				}
				// Check URL variables (Used for Simployer)
				var simployerAppid = getURLVariable("simployer-appid");
				var simployerSCI = getURLVariable("simployer-sci");
				var simployerSID = getURLVariable("simployer-sid");
				if (simployerAppid !== undefined && simployerAppid !== null && simployerAppid.length > 0) {
					setCookie(SIMPLOYER_APPID_COOKIE_NAME, simployerAppid);
				}
				if (simployerSCI !== undefined && simployerSCI !== null && simployerSCI.length > 0) {
					setCookie(SIMPLOYER_SCI_COOKIE_NAME, simployerSCI);
				}
				if (simployerSID !== undefined && simployerSID !== null && simployerSID.length > 0) {
					setCookie(SIMPLOYER_SID_COOKIE_NAME, simployerSID);
				}

				loaderIndicator(true);
				_api.refreshAuthorization_POST(
					// success
					function (data, textStatus, jqXHR) {
						if (data.success === true && data.content.length > 0) {
							var response = data.content[0];
							persistTokens(response);
							getExternalLinks(clientId, response.accessToken);
						}
						else{
							loaderIndicator(false);
							sweetAlert('Error', handleServerErrorMessage(data.displayErrorMessage), "error");
							clearUserCookies();
							getFlowClients();
						}
					},
					// error
					function (jqXHR, textStatus, errorThrown) {
						loaderIndicator(false);
						sweetAlert("Error", errorThrown, "error");
					},
					// params
					refreshToken);
			} else {
				// If Simployer SAAM
				if (ctLoginComponent.bUseSimployerSaamLogin()) {
					setLocalStorage("loginType", "simployerSaam");
					
					if (getURLVariable("isAuthenticated") === "false") {
						sweetAlert({
							title: "",
							text: getResource("app.userNotAuthenticated"),
							type: "error",
							closeOnConfirm: true
						}, function() {
							window.location.href = ctLoginComponent.simployerAuthority();
						});
					} else {
						var loginUrl = ctLoginComponent.signInUrl();
						loginUrl =  updateURLParameter(loginUrl, "returnUrl", encodeURIComponent(window.location.href));
						if (getCookie(CLIENTID_COOKIE_NAME) && getCookie(CLIENTID_COOKIE_NAME) > 0) {
							loginUrl = loginUrl + "&capitechclientid=" + getCookie(CLIENTID_COOKIE_NAME);
						}
						window.location.href = loginUrl;
					}
				} else {
					setLocalStorage("loginType", "");
					clearUserCookies();
					getFlowClients();
				}
			}
		}

		function loginUser(clientId, username, password) {
			var success = function success(data, textStatus, jqXHR) {
				if (data.success === true && data.content.length === 1) {
					var response = data.content[0];
					var refreshTokenExpiration = response.refreshTokenExpires;

					rememberLoginFormDetails(refreshTokenExpiration, clientId, username);
					persistTokens(response);

					getExternalLinks(clientId, data.content[0].accessToken);
				} else {
					loaderIndicator(false);
					sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
				}
			};
			var error = function error(jqXHR, textStatus, errorThrown) {
				loaderIndicator(false);
				sweetAlert("Error", errorThrown, "error");
			};
			// Show loader
			loaderIndicator(true);
			_api.authorize_POST(success, error, clientId, username, password);
		}

		function rememberLoginFormDetails(refreshTokenExpiration, clientId, username) {
			var exp = new Date(refreshTokenExpiration);
			var rememberMe = $('input#rememberMeCheckbox').prop('checked');
			setCookie(REMEMBERME_COOKIE_NAME, rememberMe, 365);
		}

		function getExternalLinks(clientId, accessToken) {
			_api.getExternalLinks_POST(
				function (data, textStatus, jqXHR) {
					if (data.success == true) {
						setLocalStorage('myCapitechExternalLinks', data.content);
					}
				},
				function (jqXHR, textStatus, errorThrown) {
				},
				accessToken
			);
			getMyCapitechUserSettings(clientId, accessToken);
		}

		function getMyCapitechUserSettings(clientId, accessToken) {
			_api.getMyCapitechSettings_POST(
				function (data, textStatus, jqXHR) {
					if (data.success == true && data.content && data.content.length > 0) {
						var newUserSettings = getLocalStorage("myCapitechUserSettings") || {};
						var newClientSettings = getLocalStorage("myCapitechSettings");
						for (var i = 0; i < data.content.length; i++) {
							try {
								newUserSettings[data.content[i].key] = data.content[i].value;
								if (data.content[i].key === 'language') {
									newClientSettings[data.content[i].key] = getUserLanguage(data.content[i].value);
								}
							} catch (error) {
								console.warn("Can’t set user setting: ", data.content[i]);
							}
						}
						setLocalStorage("myCapitechUserSettings", newUserSettings);
						setLocalStorage("myCapitechSettings", newClientSettings);
						_appSettingsObj = newClientSettings;
					}
					getAllLocalizations(clientId, accessToken);
				},
				function (jqXHR, textStatus, errorThrown) {
					getAllLocalizations(clientId, accessToken);
				},
				accessToken
			);
		}

		function getAllLocalizations(clientId, accessToken) {
			_api.getAllLocalizations_POST(
				function (data, textStatus, jqXHR) {
					if (data.success == true) {
						languages[_appSettingsObj.language] = data.content;
						setLocalStorage('myCapitechLanguages', languages);
						getEmployeeRegistrationInformation(accessToken);
					} else {
						loaderIndicator(false);
						sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
					}
				},
				function (jqXHR, textStatus, errorThrown) {
					displayAjaxErrorAlert(jqXHR);
				},
				_appSettingsObj.languageShort,
				clientId
			);
		}

		function getEmployeeRegistrationInformation(accessToken) {
			var success = function success(data, textStatus, jqXHR) {
				if (data.success == true && data.content.length === 1) {
					var registrationSetup = data.content[0];
					setLocalStorage('myCapitechPermissionsAndRegistrationSetup', registrationSetup);

					// Check if user has shifts / duty
					if (registrationSetup.canDoManualAddition) {
						getTimeCategoryForManualAddition(accessToken);
					} else if (registrationSetup.hasCapitechPlan || registrationSetup.hasCapitechFlowPlan) {
						getDutyWishFilter(accessToken);
					} else {
						getDimensionNames(accessToken);
					}

				} else {
					sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
				}
			};
			var error = function error(jqXHR, textStatus, errorThrown) {
				sweetAlert("Error", errorThrown, "error");
			};
			_api.getEmployeeRegistrationInformation_POST(success, error, accessToken);
		}

		function getTimeCategoryForManualAddition(accessToken) {
			var success = function success(data, textStatus, jqXHR) {
				if (data.success == true) {
					if (data.content.length > 0) {
						setLocalStorage('myCapitechTimeCategoryForManualAddition', data.content);
					}
					var registrationSetup = getLocalStorage('myCapitechPermissionsAndRegistrationSetup');
					if (registrationSetup.hasCapitechPlan || registrationSetup.hasCapitechFlowPlan) {
						getDutyWishFilter(accessToken);
					} else {
						getDimensionNames(accessToken);
					}
				} else {
					sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
				}
			};
			var error = function error(jqXHR, textStatus, errorThrown) {
				sweetAlert("Error", errorThrown, "error");
			};
			_api.getTimeCategoryForManualAddition_POST(success, error, accessToken);
		}

		function getDutyWishFilter(accessToken) {
			var success = function success(data, textStatus, jqXHR) {
				if (data.success == true) {
					if (data.content.length > 0) {
						setLocalStorage('myCapitechDutyWishFilter', data.content[0]);
					}
					getPossibleValuesForDutyWishFilter(accessToken);
				} else {
					sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
				}
			};
			var error = function error(jqXHR, textStatus, errorThrown) {
				sweetAlert("Error", errorThrown, "error");
			};
			_api.getDutyWishFilter_POST(success, error, accessToken);
		}

		function getPossibleValuesForDutyWishFilter(accessToken) {
			var success = function success(data, textStatus, jqXHR) {
				if (data.success == true) {
					if (data.content.length > 0) {
						setLocalStorage('myCapitechDutyWishFilterValues', data.content[0]);
					}
					getDimensionNames(accessToken);
				} else {
					sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
				}
			};
			var error = function error(jqXHR, textStatus, errorThrown) {
				sweetAlert("Error", errorThrown, "error");
			};
			_api.getPossibleValuesForDutyWishFilter_POST(success, error, accessToken);
		}

		function getDimensionNames(accessToken) {
			var success = function success(data, textStatus, jqXHR) {
				if (data.success == true && data.content.length === 1) {
					setLocalStorage('myCapitechDimensionNames', data.content[0]);
					getUnReadMessageCount(accessToken);
				} else {
					sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
				}
			};
			var error = function error(jqXHR, textStatus, errorThrown) {
				sweetAlert("Error", errorThrown, "error");
			};
			_api.getDimensionNames_POST(success, error, accessToken, _appSettingsObj.languageShort);
		}

		function getUnReadMessageCount(accessToken) {
			var success = function success(data, textStatus, jqXHR) {
				if (data.success == true && data.content.length === 1) {
					setLocalStorage('myCapitechUnReadMessageCount', data.content[0]);
					window.location.href = 'dashboard.htm?v={gulp-my-capitech-version}';
				} else {
					sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
				}
			};
			var error = function error(jqXHR, textStatus, errorThrown) {
				sweetAlert("Error", errorThrown, "error");
			};
			_api.getNumberOfPendingIncomingMessages_POST(success, error, accessToken);
		}

		// event handlers
		/*////////////////////////////////////////////////////////////*/
		$(this).on('submit', function (evt) {
			evt.preventDefault();

			var clientId = $capitechLoginElm.find('select#clientId').val(),
				username = $capitechLoginElm.find('input#username').val(),
				password = $capitechLoginElm.find('input#password').val();

			loginUser(clientId, username, password);
		});

		$(this).on('click', 'button.login-action', function (evt) {
			var loginType = $(this).val();
			ctLoginComponent.loginType(loginType);
			if (ctLoginComponent.clientId() !== undefined && ctLoginComponent.clientId() > 0 && loginType === "externalLogin") {
				evt.preventDefault();
				window.location.href = ctLoginComponent.externalAuthUrlWithClientId();
			}
		});

		// init
		/*////////////////////////////////////////////////////////////*/
		init();

		return plugin;
	};
}(jQuery));

function shouldRememberMe() {
	return getCookie(REMEMBERME_COOKIE_NAME) ? true : false;
}

function clearUserCookies() {
	eraseCookie(REFRESHTOKEN_COOKIE_NAME);
	eraseCookie(ACCESSTOKEN_COOKIE_NAME);
	eraseCookie(SIMPLOYER_APPID_COOKIE_NAME);
	eraseCookie(SIMPLOYER_SCI_COOKIE_NAME);
}

function persistTokens(response) {
	var refreshTokenExpiration = new Date(response.refreshTokenExpires);
	var accessTokenExpiration = new Date(response.accessTokenExpires);

	if (shouldRememberMe() !== true && getLocalStorage("loginType") !== "simployerSaam") {
		refreshTokenExpiration = accessTokenExpiration;
	}

	setCookie(REFRESHTOKEN_COOKIE_NAME, response.refreshToken, refreshTokenExpiration);
	setCookie(ACCESSTOKEN_COOKIE_NAME, response.accessToken, accessTokenExpiration);

	setLocalStorage('myCapitechAccessTokenExpires', response.accessTokenExpires);
	setLocalStorage('myCapitechLogin', new Date());
}
